import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-up', 'ArrowLongUp', [["path",{"d":"m16 6-4-4-4 4m4-4v20","key":"svg-0"}]]);